import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  ConfigService,
  EntityParams,
  EntityService,
  TokenService
} from 'viggo-sistemas-core-web';
import { IEntityPagination } from 'viggo-sistemas-core-web/modules/core/model/entity.model';
import { IContratoPrecificacao } from '../models/contrato_precificacao.model';

@Injectable()
export class ContratoPrecificacaoService extends EntityService<
  IContratoPrecificacao
> {
  constructor(

    protected configService: ConfigService,
    protected tokenService: TokenService
  ) {
    super({
      baseEntityEndPoint: 'contrato_viggo',
      urlBackend: configService.backendURL
    });
  }

  private getHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    if (this.tokenService.getToken())
      headers = headers.append('token', this.tokenService.getToken().id);
    return headers;
  }

  /**
   * Adciona um termo ao contrato
   * @param contrato_id identificador do contrato
   * @param imagem
   */
  public addTermoAceite(
    contrato_id: string,
    termo_id: string
  ): Observable<any> {
    const url = `${this.baseURL}/${contrato_id}/add_termo_aceite`;

    return this.http.put<any>(
      url,
      { termo_aceite_id: termo_id },
      { headers: this.getHeaders() }
    );
  }

  /**
   * Adciona um termo ao contrato
   * @param contrato_id identificador do contrato
   * @param imagem
   */
  public removerTermoAceite(
    contrato_id: string,
    termo_id: string
  ): Observable<any> {
    const url = `${this.baseURL}/${contrato_id}/rem_termo_aceite`;

    return this.http.put<any>(
      url,
      { termo_aceite_id: termo_id },
      { headers: this.getHeaders() }
    );
  }

  /**
   * Pesquisa uma lista de entidades apartir de um parametro repassado
   * @param params parametros repassados
   * @param domainId identificador do domain a ser buscado
   */
  override getEntitiesByParams(
    params: string | EntityParams<IContratoPrecificacao>,
    domainId?: string,
    require_pagination = false
  ): Observable<any> {
    // T[] | IEntityPagination<T[]>
    let paramsAux: string = null;
    let paramsHttp = new HttpParams();

    if (typeof params === 'string') {
      paramsAux = `?${params}${
        require_pagination ? '&require_pagination=true' : ''
      }`;
      if (domainId) paramsAux += `&domain_id=${domainId}`;
    } else {
      if (params.where) paramsHttp = this.getParams(params.where);
      if (domainId) paramsHttp = paramsHttp.set('domain_id', domainId);
      if (require_pagination) {
        paramsHttp = paramsHttp.set('require_pagination', require_pagination);
      }
      if (params.pagination) {
        paramsHttp = paramsHttp.set('page', params.pagination.page);
        paramsHttp = paramsHttp.set('page_size', params.pagination.page_size);
      }
      if (params.include && params.include.length)
        paramsHttp = paramsHttp.set('include', params.include.join(','));
      if (params.order_by && params.order_by.length)
        paramsHttp = paramsHttp.set('order_by', params.order_by.join(','));
      if (params.list_options)
        paramsHttp = paramsHttp.set('list_options', params.list_options);
      paramsAux = null;
    }

    const url = this.baseURL + (paramsAux || '');

    return this.http
      .get<any>(url, {
        headers: this.getHeader(),
        params: paramsHttp
      })
      .pipe(
        map(data => {
          if (require_pagination) {
            data = data as IEntityPagination<IContratoPrecificacao>;
            return {
              data: data[this.entitiesName],
              pagination: data.pagination,
              valor_total_contratos: data.valor_total_contratos,
            };
          }
          data = data as IContratoPrecificacao[];
          return data[this.entitiesName];
        }),
        catchError(this.handleError)
      );
  }

  /**
   * Função responsável por listar os dominios sem contrato
   * @param where
   * @returns
   */
  dominiosDiponiveis(where: any) {
    const url = `${this.baseURL}/domain_disponiveis`;
    var params = new HttpParams();

    if (where && typeof where === 'object' && Object.keys(where).length !== 0) {
      Object.keys(where).forEach(key => {
        if (
          where[key] !== null &&
          where[key] !== undefined
        ) {
          if (Array.isArray(where[key])) {
            params = params.append(`${key}`, where[key].join(','));
          } else {
            params = params.append(`${key}`, where[key]);
          }
        }
      });
    }

    return this.http
      .get<any>(url, {
        params: params,
        headers: this.getHeader()
      })
      .pipe(
        map(data => {
          if (where.require_pagination) {
            data = data as IEntityPagination<any>;
            return {
              data: data['domains'],
              pagination: data.pagination
            };
          }
          data = data as any[];
          return data[this.entitiesName];
        }),
        catchError(this.handleError)
      );
  }
}
